import { useSyncExternalStore } from 'react';
import { getLanguage, setLanguage, subscribeLanguage } from '@/lib/i18n';
import type { Translate } from '@/lib/i18n';

const french: Translate = (fr) => fr;
const english: Translate = (_fr, en) => en;

export function useI18n() {
  const language = useSyncExternalStore(subscribeLanguage, getLanguage, getLanguage);
  return {
    language,
    setLanguage,
    locale: language === 'en' ? 'en-US' : 'fr-FR',
    t: language === 'en' ? english : french,
  };
}
